import React from 'react';
import SectionHeader from 'components/text/SectionHeader';
import CheckboxInput from 'components/inputs/CheckboxInput';
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import Button from 'components/common/Button';
import Card from 'antd/lib/card';
import message from 'antd/lib/message';
import { graphql } from 'react-apollo'
import saveContactFormSettings from 'ApolloClient/Mutations/saveContactFormSettings';
import FormItem from 'components/common/FormItem';

class ContactSettingsArea extends React.PureComponent {
  state = {
    phone: this.props.organization.contactForm.phone || false,
    eventDate: this.props.organization.contactForm.eventDate || false,
    eventType: this.props.organization.contactForm.eventType || false,
    venue: this.props.organization.contactForm.venue || false,
    whereDidYouHearAboutUs: this.props.organization.contactForm.whereDidYouHearAboutUs || false,
  };

  onChange = newValue => {
    this.setState(newValue);
  };

  onSave = async (variables, refetchQueries) => {
    if (!this.props.organization) {
      return console.log('this.props.organization')
    }
    let optimisticResponse = {
      saveContactFormSettings: {
        _id: this.props.organization._id,
        __typename: 'Organization',
        ...variables,
      },
    };

    let res;
    try {
      await this.props.saveContactFormSettings({ variables, optimisticResponse });
    } catch(err){
      return console.log(err)
    }
    this.setState({ loading: false });
      // handleCancel();
      message.success('successfully saved!', 3);
  };

  handleSubmit = e => {
    e.preventDefault();
    this.onSave({ 
        _id: this.props.organization._id,
        params: {
          ...this.state,
        },
    });
  };

  render() {

    return (
      <div>
        <div style={{ position: 'relative' }}>
          <SectionHeader>CONTACT FORM FIELDS</SectionHeader>
        </div>
        <div style={{ width: 550, maxWidth: '100%' }}>
          <Card
            bodyStyle={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Row style={{margin: 20}}>
              <Col xs={12}>
                <FormItem>
                  <CheckboxInput checked={false} disabled>
                    First Name
                  </CheckboxInput>
                </FormItem>
              </Col>
              <Col xs={12}>
              <FormItem>
                <CheckboxInput checked={false} disabled>
                  Last Name
                </CheckboxInput>
                </FormItem>
              </Col>
              <Col xs={12}>
              <FormItem>
                <CheckboxInput checked={false} disabled>
                  Email
                </CheckboxInput>
                </FormItem>
              </Col>
              <Col xs={12}>
              <FormItem>
                <CheckboxInput checked={false} disabled>
                  Message
                </CheckboxInput>
                </FormItem>
              </Col>
              <Col xs={12}>
              <FormItem>
                <CheckboxInput
                  onChange={e => this.onChange({
                    phone: e.target.checked,
                  })
                  }
                  checked={this.state.phone}
                >
                  Phone
                </CheckboxInput>
                </FormItem>
              </Col>
              <Col xs={12}>
              <FormItem>
                <CheckboxInput
                  onChange={e => this.onChange({
                    eventDate: e.target.checked,
                  })
                  }
                  checked={this.state.eventDate}
                >
                  Session Date
                </CheckboxInput>
                </FormItem>
              </Col>
              <Col xs={12}>
              <FormItem>
                <CheckboxInput
                  onChange={e => this.onChange({
                    eventType: e.target.checked,
                  })
                  }
                  checked={this.state.eventType}
                >
                  Session Type
                </CheckboxInput>
                </FormItem>
              </Col>
              <Col xs={12}>
              <FormItem>
                <CheckboxInput
                  onChange={e => this.onChange({
                    venue: e.target.checked,
                  })
                  }
                  checked={this.state.venue}
                >
                  Venue
                </CheckboxInput>
                </FormItem>
              </Col>
              <Col xs={24}>
              <FormItem>
                <CheckboxInput
                  onChange={e => this.onChange({
                    whereDidYouHearAboutUs: e.target.checked,
                  })
                  }
                  checked={this.state.whereDidYouHearAboutUs}
                >
                  Where did you hear about us?
                </CheckboxInput>
                </FormItem>
              </Col>
              <Col xs={24}>
                <Button onClick={this.handleSubmit}>Save</Button>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    );
  }
}

export default graphql(saveContactFormSettings, { name: 'saveContactFormSettings'})(ContactSettingsArea);



// WEBPACK FOOTER //
// ./src/routes/app-studio/ContactSettingsArea/index.js